import { Box, Container, Typography, Card, CardContent, Chip } from '@mui/material'

export default function HowItWorks() {
  const steps = [
    {
      number: '1',
      icon: '📱',
      title: 'Leia o QR Code',
      description: 'Cliente aponta a câmera para o QR Code na mesa',
    },
    {
      number: '2',
      icon: '✨',
      title: 'Escolha o Serviço',
      description: 'Selecione entre Garçom, Conta ou Cardápio',
    },
    {
      number: '3',
      icon: '⚡',
      title: 'Notificação Instantânea',
      description: 'Chega em tempo real para garçom e cozinha',
    },
    {
      number: '4',
      icon: '✅',
      title: 'Atendimento Confirmado',
      description: 'Cliente recebe confirmação do atendimento',
    },
  ]

  const benefits = [
    { icon: '💰', title: 'Econômico', desc: 'Sem banco de dados complexo, infraestrutura serverless' },
    { icon: '⚡', title: 'Implementação Rápida', desc: 'MVP funcional em menos de 1 hora de setup' },
    { icon: '🚀', title: 'Escalabilidade', desc: 'Cresce automaticamente com suas necessidades' },
  ]

  return (
    <Box
      component="section"
      id="how-it-works"
      sx={{
        py: { xs: 2, md: 4 },
        px: { xs: 2, sm: 3, lg: 4 },
        background: 'linear-gradient(180deg, #f9fafb 0%, #ffffff 100%)',
      }}
    >
      <Container maxWidth="lg" sx={{ pt: 0 }}>
        {/* Section Title */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2.25rem', md: '3.75rem' },
              fontWeight: 900,
              color: '#1f2937',
              mb: 2,
            }}
          >
            Como Funciona
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: '1rem', md: '1.1rem' },
              color: '#6b7280',
              maxWidth: '700px',
              mx: 'auto',
              textAlign: 'center',
            }}
          >
            4 passos simples para transformar a experiência de atendimento
          </Typography>
        </Box>

        {/* Steps Timeline */}
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(4, 1fr)' }, gap: 4, mb: 10, position: 'relative', zIndex: 1 }}>
          {steps.map((step, idx) => (
            <Box key={step.number} sx={{ textAlign: 'center', position: 'relative' }}>
              {/* Connector Line */}
              {idx < steps.length - 1 && (
                <Box
                  sx={{
                    display: { xs: 'none', md: 'block' },
                    position: 'absolute',
                    top: '40px',
                    left: '50%',
                    width: '200%',
                    height: '4px',
                    background: 'linear-gradient(90deg, #dc2626 0%, #f97316 100%)',
                    transform: 'translateX(-25%)',
                    zIndex: 0,
                  }}
                />
              )}

              {/* Step Badge */}
              <Chip
                label={`Passo ${step.number}`}
                sx={{
                  position: 'absolute',
                  top: -12,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  backgroundColor: '#dc2626',
                  color: 'white',
                  fontWeight: 700,
                  fontSize: '0.75rem',
                  height: 'auto',
                  py: 0.5,
                  zIndex: 20,
                }}
              />

              {/* Icon Circle */}
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #dc2626 0%, #f97316 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '2.5rem',
                  mx: 'auto',
                  mb: 2,
                  boxShadow: '0 0 30px rgba(220, 38, 38, 0.15)',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.1)',
                  },
                  zIndex: 10,
                  position: 'relative',
                }}
              >
                {step.icon}
              </Box>

              {/* Content */}
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: '#1f2937',
                  mb: 1,
                }}
              >
                {step.title}
              </Typography>
              <Typography
                sx={{
                  color: '#6b7280',
                  fontSize: '0.95rem',
                }}
              >
                {step.description}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Benefits Grid */}
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' }, gap: 3, maxWidth: '1000px', mx: 'auto' }}>
          {benefits.map((benefit) => (
            <Card
              key={benefit.title}
              elevation={0}
              sx={{
                h: '100%',
                border: '1px solid #e5e7eb',
                borderRadius: '1rem',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
                },
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <Typography sx={{ fontSize: '2.5rem', mb: 2 }}>
                  {benefit.icon}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: '#1f2937',
                    mb: 1,
                  }}
                >
                  {benefit.title}
                </Typography>
                <Typography sx={{ color: '#6b7280', fontSize: '0.95rem', lineHeight: 1.6 }}>
                  {benefit.desc}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>
      </Container>
    </Box>
  )
}
